import React from 'react';
import { Navbar, Nav, Container, Image, Dropdown } from 'react-bootstrap';
import { Bell, PersonCircle } from 'react-bootstrap-icons';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { logout } from '../../../store/authSlice';
import store from '../../../store';

const HeaderContainer = styled.div`
.navbar {
    background-color: #101632;
    border-bottom: solid 1px #2A2D45;
  }

  .navbar-brand {
    color: #9197B4;
  }

  .navbar-nav .nav-link {
    font-size: 16px;
    font-weight: 600;
    color: #9197B4;
    display: flex;
    align-items: center;
  }
`;

const Header: React.FC = () => {

  const dispatch = useDispatch();

  const authInfo = store.getState().auth.authInfo;

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <HeaderContainer>
      <Navbar expand="lg" fixed="top">
        <Container fluid>
          <Navbar.Brand href="/">
            <Image
              src="/static/images/logo-192x192.png"
              height={30}
              className="d-inline-block align-top me-2"
              alt="Logo"
            />
            console
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbar-nav" />
          <Navbar.Collapse id="navbar-nav">
            <Nav className="ms-auto align-items-center">
              <Nav.Link href="/reports">
                <Bell className="me-2" />
              </Nav.Link>
              <Dropdown align="end">
                <Dropdown.Toggle as={Nav.Link} className="d-flex align-items-center">
                  <PersonCircle className="me-2" />
                  {authInfo?.fullName}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item href="#account">Account Settings</Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item id="SignOut" onClick={handleLogout}>Sign out</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </HeaderContainer>
  );
};

export default Header;
